// 학원관리 필드명 리스트
export const InstituteAttributes = Object({
    addressSearch :  '검색주소',
    branchSeq :  '소속지사 seq',
    businessNumber :  '사업자 번호',
    campusName :  '캠퍼스명',
    contractorName :  '계약자(사업자)명',
    contractorRelation :  '계약자(사업자)와의 관계',
    createDate :  '정보입력일',
    discount :  '',
    discountMethod:  '',
    displayChk :  '홈페이지 노출',
    domain :  '도메인',
    eMail :  '학원 대표 이메일',
    fax :  '팩스 번호',
    frContractDate :  '가맹 계약일',
    instituteChiefID :  '학원장 ID',
    instituteName :  '학원명',
    instituteSeq :  '',
    ip:  '',
    memo :  '특이사항 메모',
    mobilephone :  '학원 대표 이동전화',
    presidentName :  '실제운영 학원장명',
    presidentRelation :  '사업자와의 관계',
    reserveMoney :  '학원적립금',
    specialItem :  'specialItem',
    telephone :  '(홈피노출) 전화번호',
    testChk:  '',
    testChk1:  '',
    testEndDate:  '',
    testStartDate:  '',
    zipCode :  '우편번호',
    zipDetail :  '주소 세부',
    zipName :  '주소',
})